export default "/assets/images/list-icon2.29a20d23cc10ae5b.svg";